import React from 'react';
import PropTypes from 'prop-types';
import LoadingIcon from '@tradera/blueprint/theme/icons2/loading.svg?jsx';
import { Accordion, AccordionItem } from 'tradera-components/accordion';

import { FilterCategories } from './filter-categories';

import { useTranslator } from 'tradera-lang/translate';

const FilterCategoriesModal = ({
    filterCategories,
    handleCategoryChange,
    handleSearchCategoryChange,
    pageType,
    isUpdating,
    queryParams
}) => {
    const { t } = useTranslator();
    return (
        <>
            <div className="search-modal__header d-flex justify-content-center align-items-center font-weight-bold">
                {t('categoryFilterModal_title')}
            </div>
            {isUpdating && (
                <div className="search-filter__loading d-flex bg-white">
                    <LoadingIcon className="icon icon-xl icon-spin m-auto" />
                </div>
            )}
            <Accordion>
                <AccordionItem
                    title={t('categoryFilterModal_allCategories')}
                    defaultOpen={true}
                    collapsable={false}
                    hideTitle={true}
                    className="bg-white"
                    render={() => (
                        <FilterCategories
                            filterCategories={filterCategories}
                            handleCategoryChange={handleCategoryChange}
                            handleSearchCategoryChange={
                                handleSearchCategoryChange
                            }
                            pageType={pageType}
                            queryParams={queryParams}
                        />
                    )}
                />
            </Accordion>
        </>
    );
};

FilterCategoriesModal.propTypes = {
    filterCategories: PropTypes.shape({
        categoryTree: PropTypes.object,
        parameter: PropTypes.string,
        type: PropTypes.string
    }).isRequired,
    handleCategoryChange: PropTypes.func,
    handleSearchCategoryChange: PropTypes.func,
    pageType: PropTypes.string.isRequired,
    isUpdating: PropTypes.bool,
    queryParams: PropTypes.object.isRequired
};

export default FilterCategoriesModal;
